import React from 'react';

const Card = ({ children, title, className = '' }) => (
  <div className={`m-3 overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm ${className}`}>
    {title && <h2 className="border-b border-slate-200 bg-slate-50 px-4 py-3 text-lg font-semibold text-slate-800">{title}</h2>}
    <div className="p-4">{children}</div>
  </div>
);

export default Card;
